// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/small-kofi.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: var(--bg-color);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid var(--secondary-text);
}

.header-button {
  width: 40px;
  height: 40px;
  border: none;
  cursor: pointer;
  background: none;
  transition: transform 0.5s ease;
}

.header-button:hover {
  transform: scale(1.3);
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  width: 200px;
  margin: 0px 10px;
}

.header-logo {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  font-family: "Leckerli One", cursive;
  font-size: 3rem;
  color: var(--primary-text);
  cursor: default;
  margin: 0px 10px;
}

.header-logo span {
  transition: color 0.5s;
}

.header-logo span.random-color {
  color: var(--random-color);
}

@media (hover: hover) {
  .header-logo span:hover {
    color: var(--random-hover-color);
  }
}

@media screen and (max-width: 650px) {
  .header-logo {
    font-size: 2rem;
  }

  .button-container {
    gap: 10px;
    width: 130px;
  }

  .header-button {
    width: 35px;
    height: 35px;
  }

  .ko-fi-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ko-fi-image img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: inline-block;
    margin: 0px 10px;
    width: 40px;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gDAA2C;IAC3C,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 20px;\r\n  background-color: var(--bg-color);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  border-bottom: 2px solid var(--secondary-text);\r\n}\r\n\r\n.header-button {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: none;\r\n  cursor: pointer;\r\n  background: none;\r\n  transition: transform 0.5s ease;\r\n}\r\n\r\n.header-button:hover {\r\n  transform: scale(1.3);\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 30px;\r\n  width: 200px;\r\n  margin: 0px 10px;\r\n}\r\n\r\n.header-logo {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  font-family: \"Leckerli One\", cursive;\r\n  font-size: 3rem;\r\n  color: var(--primary-text);\r\n  cursor: default;\r\n  margin: 0px 10px;\r\n}\r\n\r\n.header-logo span {\r\n  transition: color 0.5s;\r\n}\r\n\r\n.header-logo span.random-color {\r\n  color: var(--random-color);\r\n}\r\n\r\n@media (hover: hover) {\r\n  .header-logo span:hover {\r\n    color: var(--random-hover-color);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n  .header-logo {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .button-container {\r\n    gap: 10px;\r\n    width: 130px;\r\n  }\r\n\r\n  .header-button {\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n\r\n  .ko-fi-image {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .ko-fi-image img {\r\n    content: url(\"../../assets/small-kofi.png\");\r\n    display: inline-block;\r\n    margin: 0px 10px;\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
